// 策略类型
export enum StrategyType {
  // ⽤电成本优化
  COST_OPTIMIZATION = 1,
  // 供电保障优化
  SUPPLY_GUARANTEE_OPTIMIZATION,
  // 绿电消纳优化
  GREEN_POWER_DISPOSAL_OPTIMIZATION,
}

export const strategyTypeMap = {
  [StrategyType.COST_OPTIMIZATION]: '用电成本优化',
  [StrategyType.SUPPLY_GUARANTEE_OPTIMIZATION]: '供电保障优化',
  [StrategyType.GREEN_POWER_DISPOSAL_OPTIMIZATION]: '绿电消纳优化',
};

// 应用状态
export enum StrategyStatusEnum {
  // 未应用
  DISABLED = 0,
  // 应用中
  ENABLED = 1,
}

export const strategyStatusMap = {
  [StrategyStatusEnum.ENABLED]: '应用中',
  [StrategyStatusEnum.DISABLED]: '未应用',
};

// 求解数据定时任务 H,15M
export enum SolveResolutionType {
  HOUR = 'H', // 小时
  FIFTEEN = '15M', // 15分钟
}

export const SolveResolutionTypeDisplay = {
  [SolveResolutionType.HOUR]: '1小时',
  [SolveResolutionType.FIFTEEN]: '15分钟',
};

// 策略类型
export enum StrategyTypeEnum {
  PRESET = 1,
  CUSTOM = 2,
}

export const StrategyTypeEnumDisplay = {
  [StrategyTypeEnum.PRESET]: '预设策略',
  [StrategyTypeEnum.CUSTOM]: '自定义策略',
};

// 预设策略参数
// 1.⽤电成本优化 2.供电保障优化 3.绿电消纳优化 4.应急备电策略 5.虚拟电厂策略
export enum PreSetStrategyParamEnum {
  COST_OPTIMIZATION = 1,
  SUPPLY_GUARANTEE_OPTIMIZATION = 2,
  GREEN_POWER_DISPOSAL_OPTIMIZATION = 3,
  EMERGENCY_BACKUP_POWER = 4,
  VIRTUAL_POWER_PLANT = 5,
}
export const PreSetStrategyParamEnumDisplay = {
  [PreSetStrategyParamEnum.COST_OPTIMIZATION]: '最小用电成本',
  [PreSetStrategyParamEnum.SUPPLY_GUARANTEE_OPTIMIZATION]: '最大供电保障',
  [PreSetStrategyParamEnum.GREEN_POWER_DISPOSAL_OPTIMIZATION]: '最大绿电消纳',
  [PreSetStrategyParamEnum.EMERGENCY_BACKUP_POWER]: '应急备电策略',
  [PreSetStrategyParamEnum.VIRTUAL_POWER_PLANT]: '虚拟电厂策略',
};

export enum IndicatorEnum {
  CUMULATE = 1, // 累积
  INSTANT, // 顺时
}

export const IndicatorEnumDisplay = {
  [IndicatorEnum.CUMULATE]: '累积量',
  [IndicatorEnum.INSTANT]: '瞬时量',
};
